import { render, staticRenderFns } from "./HomeContainer.vue?vue&type=template&id=8085e16a&scoped=true"
import script from "./HomeContainer.vue?vue&type=script&lang=js"
export * from "./HomeContainer.vue?vue&type=script&lang=js"
import style0 from "./HomeContainer.vue?vue&type=style&index=0&id=8085e16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8085e16a",
  null
  
)

export default component.exports